import getDatePartOfStamp from "./getDatePartOfStamp";

const onDateEdit = (date, name, component) => {
  const dateString = date ? getDatePartOfStamp(date) : '';
  
  component.props.customFormEdit(name, dateString);
};

export default onDateEdit;
